// Utilities
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useMobileStore = defineStore('displayStore', () => {
  const mobile = ref(false)
  const tablet = ref(false)

  function setMobile(payload: boolean) {
    mobile.value = payload
  }

  function setTablet(payload: boolean) {
    tablet.value = payload
  }

  // Provide computed for reactive access
  const isMobile = computed(() => mobile.value)
  const isTablet = computed(() => tablet.value)

  return {
    mobile: isMobile,
    tablet: isTablet,
    setMobile,
    setTablet
  }
})
